<template>
    <alert-card
        v-if="officeAlert"
        :alerts="[officeAlert]"
    ></alert-card>
    <alert-card
        v-if="teacherAlerts.length"
        :alerts="teacherAlerts"
    ></alert-card>
</template>

<script setup>
    import { ref } from 'vue';
    import { GetAlertText } from '../../api/Dashboard';
    import AlertCard from './AlertCard.vue';

    const officeAlert = ref(null);
    const teacherAlerts = ref([]);

    GetAlertText().then(response => {
        const { alert_html: officeAlertHtml, office_name: officeName, teacher_alerts: teacherAlertData } = response.data;

        if (officeAlertHtml) {
            officeAlert.value = {
                id: 'office',
                title: $t('Viktig informasjon fra {office}', { office: officeName }),
                content: officeAlertHtml,
                isHtml: true,
            };
        }

        teacherAlerts.value = teacherAlertData.map(alert => ({
                id: `teacher-${alert.teacher_id}`,
                title: $t('Informasjon fra {teacher}', { teacher: alert.teacher_name }),
                content: alert.information,
                isHtml: false,
            }));
    });
</script>
